import request from './Request';
import { getCompanyId, getCompanyName, getPureWhitelabel, getShowcase } from './Amalgam';
import { smsServiceEndPoint } from '../../config';
import sha256 from 'crypto-js/sha256';

export const sendSMS = (phoneNumber) =>
  request({
    method: 'POST',
    url: '/api/sms/generate-otp',
    params: {
      phoneNumber,
      pureWhitelabel: getPureWhitelabel(),
      companyName: getCompanyName(),
      companyId: getCompanyId(),
      service: 'TWILIO'
    }
  });

export const validateCode = (phoneNumber, code) =>
  request({
    method: 'POST',
    url: '/api/sms/validate-otp',
    params: { phoneNumber, code }
  });

export const generateNonce = (currentTimeStamp, deviceToken, service, productType) =>
  request({
    method: 'POST',
    url: `${smsServiceEndPoint}/v1/sms/nonce?client=WEB`,
    params: {
      pureWhitelabel: getPureWhitelabel(),
      companyName: getCompanyName(),
      companyId: getCompanyId(),
      currentTimeStamp: currentTimeStamp,
      deviceToken: deviceToken,
      service: service,
      productType: productType
    }
  });

export const sendOTP = (phoneNumber, countryCode, deviceToken, service, productType, nonce) =>
  request({
    method: 'POST',
    url: `${smsServiceEndPoint}/v1/sms/send-otp?client=WEB`,
    params: {
      pureWhitelabel: getPureWhitelabel(),
      companyName: getCompanyName(),
      companyId: getCompanyId(),
      phoneNumber: phoneNumber,
      countryCode: countryCode,
      deviceToken: deviceToken,
      service: service,
      productType: productType,
      nonce: nonce
    }
  });

export const resendOTP = (phoneNumber, countryCode, deviceToken, service, productType, nonce) =>
  request({
    method: 'POST',
    url: `${smsServiceEndPoint}/v1/sms/resend-otp?client=WEB`,
    params: {
      pureWhitelabel: getPureWhitelabel(),
      companyName: getCompanyName(),
      companyId: getCompanyId(),
      phoneNumber: phoneNumber,
      countryCode: countryCode,
      deviceToken: deviceToken,
      service: service,
      productType: productType,
      nonce: nonce
    }
  });

export const validateOtp = (otp, phoneNumber) =>
  request({
    method: 'POST',
    url: `${smsServiceEndPoint}/v1/sms/verify-otp?client=WEB`,
    params: {
      otp: otp,
      phoneNumber: phoneNumber,
      productType: 'CATALOGUE'
    },
    headers: {
      Authorization: '660553e0-cd2d-4764-a28f-793e26b51caa'
    }
  });

export const shouldVerifyOTP = () => !!getShowcase().verifyOTP;

export const generateOtp = async (
  deviceToken,
  otpType,
  phoneNumber,
  countryCode,
  isResend
) => {
  const currentTimeStamp = new Date().toISOString();
  const response = await generateNonce(currentTimeStamp, deviceToken, otpType, 'CATALOGUE');
  const nonce = sha256(response.nonce + currentTimeStamp).toString();
  if (!isResend) {
    await sendOTP(phoneNumber, countryCode, deviceToken, otpType, 'CATALOGUE', nonce);
  } else {
    await resendOTP(phoneNumber, countryCode, deviceToken, otpType, 'CATALOGUE', nonce);
  }
};
